import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../dashboard-section.css';

function DashboardSection({ icon, title, action, children, id, className = '' }) {
    return (
        <section className={`dashboard-section ${className}`} id={id}>
            {title && (
                <div className="dashboard-section__header">
                    {icon && (
                        <span className="dashboard-section__icon">
                            <FontAwesomeIcon icon={icon} />
                        </span>
                    )}
                    <h2 className="dashboard-section__title">{title}</h2>
                    {action && <div className="dashboard-section__action">{action}</div>}
                </div>
            )}
            <div className="dashboard-section__body">
                {children}
            </div>
        </section>
    );
}

export default DashboardSection;
